/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState } from "react";
import { AlertContext, AlertType, IAlert } from "app/context/useAlert";


export const AlertProvider = ({ children } : {children : React.ReactNode}) => {
    const [alert, setAlert] = useState<IAlert>({title: '', show: false, type: "info"})
    const open = (ttl: string, tp: AlertType) => { setAlert(prev => ({...prev, show: true, title: ttl, type: tp})); setTimeout(() => setAlert(prev => ({...prev, show: false})), 5000)}
    const close = () => setAlert(prev => ({...prev, show: false, title: ''}))
    return (
        <AlertContext.Provider value={{alert, open, close}}>
            { children }
        </AlertContext.Provider>
    )
}